import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'percentage',
      label: i18n.t('common_words.percentage'),
      align: 'center',
      minWidth: 160,
      sortable: true,
    },
    {
      prop: 'start_date',
      label: i18n.t('common_words.starting_date'),
      align: 'center',
      minWidth: 160,
      sortable: true,
    },
    {
      prop: 'business.name',
      label: i18n.t('common_words.company'),
      sortable: true,
      show: false,
    },
  ];

  return { tableColumns };
};

export default configTable;
